/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { compose } from 'recompose';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import Retracked from 'js/lib/retracked';
import user from 'js/lib/user';

import { AUTHENTICATION_MODAL_MODES } from 'bundles/authentication-common/constants';
import SimplifiedHeaderInjectedSearch from 'bundles/composable-page-header-consumer/header-renderers/SimplifiedHeaderInjectedSearch';
import InCourseSearchBarGridItem from 'bundles/composable-page-header-in-course/components/InCourseSearchGridItem';
import UniversalPageFeatures from 'bundles/composable-page-header/components/UniversalPageFeatures';
import type { Stores } from 'bundles/in-course-search/appEnv';
import ErrorBoundaryWithLogging from 'bundles/page/components/ErrorBoundaryWithLogging';
import AuthenticationOption from 'bundles/user-account/components/AuthenticationOption';

import 'css!../__styles__/index';

import CourseDataProvider from './CourseDataProvider';

const styles = {
  styleFixes: css`
    .sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      margin: -1px;
      padding: 0;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      border: 0;
    }
  `,
};

type Props = {
  requestCountryCode?: string | null;
  csrfToken?: string | null;
};

const InCourseSearchApp = ({ children }: React.PropsWithChildren<Props>) => (
  <main data-test="rc-InCourseSearchApp" css={styles.styleFixes}>
    <CourseDataProvider>
      <SimplifiedHeaderInjectedSearch injectedSearch={<InCourseSearchBarGridItem isInternal />} showProgramSwitcher />
      <UniversalPageFeatures />
      <ErrorBoundaryWithLogging>
        {user.isAuthenticatedUser() ? (
          children
        ) : (
          <AuthenticationOption defaultMode={AUTHENTICATION_MODAL_MODES.LOGIN} />
        )}
      </ErrorBoundaryWithLogging>
    </CourseDataProvider>
  </main>
);

export default compose<{}, React.PropsWithChildren<Props>>(
  connectToStores<Props, {}, Stores>(['ApplicationStore'], ({ ApplicationStore }, props) => ({
    ...props,
    csrfToken: ApplicationStore.getState().csrfToken,
    requestCountryCode: ApplicationStore.getState().requestCountryCode,
  })),
  Retracked.createTrackedContainer(() => ({
    namespace: {
      app: 'in_course_search',
      page: 'search',
    },
  }))
)(InCourseSearchApp);
